import React, { useState } from 'react';
import { Button, Form, Input, Modal, Space, Table, message } from 'antd';
import { useForm } from "antd/es/form/Form";
import { getDirectusClient } from "../../../lib/directus";
import { readItems } from "@directus/sdk";
import { useSelector } from "react-redux";
import { truncateSerial } from '../../../lib/utils';

const PorCaja = ({ productoselect, seriales, agregarPorCaja, arrayproductosfacturar }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [form] = useForm();
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const omitir1 = useSelector((state) => state.omitir1.omitir1);
  // Add helper function to check if serial is already selected
  const isSerialSelected = (serial) => {
    return Array.isArray(arrayproductosfacturar) && arrayproductosfacturar.some(item => 
      Array.isArray(item.seriales) && item.seriales.some(s => s.id === serial.id)
    );
  };

  const onFinish = async (values) => {
    try {
      const directus = await getDirectusClient();
      
      const response = await directus.request(
        readItems('seriales', {
          fields: [
            "bodega",
            "estado",
            "id",
            "caja",
            "user",
            "serial",
            "producto.grupo.impuesto",
            "producto.id",
            "producto.grupo.impuesto",
            "producto.nombre",
            "producto.preciosinimp",
          ],
          filter: { 
            caja: truncateSerial(values.caja, omitir1), 
            estado: 1,
           
           ...(userRoleID !== 'adminapp' && userRoleID !== 'Administrator'
            ? {
                bodega: userBodega,
              
              }
            : {}),
          },
          limit: -1,
        })
      );

      if (!response || response.length === 0) {
        Modal.error({
          title: "No se encontraron seriales activos con los datos suministrados",
        });
        setSearchResults([]);
        return;
      }

      // Group serials by product and check selected status
      const groupedSerials = response.reduce((acc, serial) => {
        const productId = serial.producto.id;
        const isSelected = isSerialSelected(serial);

        if (!acc[productId]) {
          acc[productId] = {
            key: productId,
            producto: serial.producto.nombre,
            cantidad: 1,
            seriales: [serial],
            selectedCount: isSelected ? 1 : 0,
            allSeriales: [serial]
          };
        } else {
          acc[productId].cantidad += 1;
          acc[productId].seriales.push(serial);
          if (isSelected) {
            acc[productId].selectedCount += 1;
          }
        }
        return acc;
      }, {});

      setSearchResults(Object.values(groupedSerials));
    } catch (error) {
      console.error('Error buscando seriales:', error);
      Modal.error({
        title: "Error",
        content: "Error al buscar los seriales"
      });
    }
  };

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'producto',
      key: 'producto',
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
    },
  
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record) => {
        const pendingSerials = record.seriales.filter(
          serial => !isSerialSelected(serial)
        );

        return (
          <Button 
            type="primary" 
            disabled={pendingSerials.length === 0}
            onClick={() => {
              let addedCount = 0;
              pendingSerials.forEach(serial => {
                if (!isSerialSelected(serial)) {
                  agregarPorCaja(serial, true, false); // Pass the complete serial object
                  addedCount++;
                }
              });
              
              if (addedCount > 0) {
                message.success(`Se agregaron ${addedCount} seriales nuevos del producto ${record.producto}`);
              }
            }}
          >
            {pendingSerials.length === 0 ? 'Todos Seleccionados' : 'Seleccionar Pendientes'}
          </Button>
        );
      },
    },
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Form
        form={form}
        name="searchCaja"
        layout="vertical"
        onFinish={onFinish}
      >
        <Space>
          <Form.Item
            label="Número de Caja"
            name="caja"
            rules={[{ required: true, message: 'Ingrese el número de caja!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" onClick={(e) => {
              e.preventDefault();
              form.submit();
            }}>
              Buscar
            </Button>
          </Form.Item>
        </Space>
      </Form>

      {searchResults.length > 0 && (
        <Table 
          columns={columns} 
          dataSource={searchResults}
          pagination={false}
          size="small"
        />
      )}
    </Space>
  );
};

export default PorCaja;